export default "__VITE_ASSET__CUjUtP0Z__"